var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[(_vm.$route.meta.navbar != false)?_c('top-navbar'):_vm._e(),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }